import React from "react";

const Input = React.forwardRef(
  ({ label, type = "text", className = "", wrapperClassName = "", error = null, ...props }, ref) => {
    return (
      <div className={`w-full ${wrapperClassName}`}>
        {label && (
          <label htmlFor={props.id} className="block text-sm font-medium text-muted-foreground mb-1">
            {label}
          </label>
        )}
        <input
          ref={ref}
          type={type}
          className={`ui-input ${error ? "ui-input-error" : ""} ${className}`}
          aria-invalid={error ? "true" : undefined}
          aria-describedby={error ? `${props.id || "input"}-error` : undefined}
          {...props}
        />
        {error && (
          <p id={`${props.id || "input"}-error`} className="mt-1 text-xs text-red-600 dark:text-red-400">
            {error}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";
export default Input;
